import React from 'react';
import NavItem from "./nav/NavItem";
import UserDropdown from "../../shared/ui/userDropdown/UserDropdown";
import {useRoute} from "../routes/useRoute";
import { useSelector} from "react-redux";
import {selectPharmacies, selectUser} from "../reducer/auth/authSlice";
import {selectedPharmacyAction, selectSelectedPharmacy} from "../reducer/pharmacySlice";
import {useAppDispatch} from "../../app/hooks";
import {voiceMenuComplete} from "./dataNav";
import {selectMenuVoices} from "./nav/menuSlice";


export interface NavList {
    name: string;
    label: string;
    divider?: boolean;
    child?: NavList[]
}

const Header = ({logoutHandler}: { logoutHandler: () => void }) => {
    const {changeRoute} = useRoute()
    const dispatch = useAppDispatch()
    const menu = useSelector(selectMenuVoices)

    const user = useSelector(selectUser)
    const pharmacies = useSelector(selectPharmacies);
    const selectedPharmacy = useSelector(selectSelectedPharmacy);

    const profile: NavList[] = [
        /*{
            name: 'profile',
            label: 'Profilo',
        },*/
        {
            name: 'logout',
            label: 'Logout',
            divider: true,
        }
    ]
    const pharmaciesListDrop: NavList[] = (pharmacies || [])?.map(ele => {
        return {
            name: ele.idDocument,
            label: ele.name,
        }
    })



    const clickVoice = (name: string) => {
        changeRoute(name)
        console.log(`click ${name}`);
    }
    const clickDropItem = (name: string) => {
        const actions: { [key: string]: any } = {
            profile: console.log(`click ${name}`),
            logout: logoutHandler,
        }
        actions[name] && actions[name]()
    }
    const clickSubVoiceHandler = (id: string) => {
        const pharm = pharmacies?.find(f => f.idDocument === id)
        pharm && dispatch(selectedPharmacyAction(pharm))
        // console.log('selected', name)
    }

    return (
        <header>
            <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-cyan-600 shadow">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#"><img src="./assets/logo.png" alt="logo"
                                                              onClick={() => changeRoute('')}/></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {menu?.map((item, k) => (
                                <NavItem item={item} key={k} clickVoiceHandler={clickVoice}/>
                            ))}
                        </ul>
                        <div className="d-flex flex-column">
                            <UserDropdown user={user} listDropdown={profile} showIconProfile={true}
                                          clickDropItemHandler={clickDropItem} subListDrop={pharmaciesListDrop}
                                          clickSubVoiceHandler={clickSubVoiceHandler} subData={selectedPharmacy}/>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
